export enum ProgrammableSurfacesEvents {
    Handoff = "CatalystHandoff",           // SDX → Win32 (outbound): Catalyst handoff event
    GetCampaignState = "GetCampaignState",        // SDX → Win32 (outbound): Request campaign state
    CampaignStateResponse = "CampaignStateResponse", // Win32 → SDX (inbound): Campaign state response
    UpdateCampaignState = "UpdateCampaignState",  // SDX → Win32 (outbound): Action completion update
    CampaignCompleted = "CampaignCompleted",       // SDX → Win32 (outbound): Campaign completed
    OpenDialog = "OpenDialog"               // SDX → Win32 (outbound): Open a dialog
} 

export interface ProgrammableSurfacesEvent<TEventType extends ProgrammableSurfacesEvents, TPayload = unknown> {
    eventType: TEventType;
    payload?: TPayload;
}

/**
 * Helper type for events that require a payload.
 * Use for events that always carry data (e.g., CampaignStateResponse).
 */
export type ProgrammableSurfacesEventWithPayload<
    TEventType extends ProgrammableSurfacesEvents,
    TPayload
> = Required<ProgrammableSurfacesEvent<TEventType, TPayload>>;

/**
 * Helper type for events that never have a payload.
 * Use for request-style events (e.g., GetCampaignState).
 */
export type ProgrammableSurfacesEventWithoutPayload<
    TEventType extends ProgrammableSurfacesEvents
> = Omit<ProgrammableSurfacesEvent<TEventType, never>, 'payload'>;

export interface ProgrammableSurfacesTransport<TEventType extends ProgrammableSurfacesEvents, TPayload = unknown> {
    sendEvent(event: ProgrammableSurfacesEvent<TEventType, TPayload>): void;
}